module.exports = __webpack_public_path__ + "img/H-B-123456-unload-standup-top.da919040.png";